import { Devices as Device} from "patients-experience-client";
import React, { useEffect, useState } from "react";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import { AddUpdateDevice } from "./AddUpdateDevice";
import OffCanvas from "../../../../components/offCanvas";
import Toaster, { ToastConfig } from "../../../../components/Toaster";
import { ErrorTypes } from "../../../../interfaces/errors";
import Spinner from "../../../../components/Spinner";
import ConfirmationBox from "../../../../components/ConfirmationBox";
import { ReactComponent as EditIcon } from "../../../../assets/img/EditTask.svg";

interface DeviceProps {
    patientId: string | undefined;
}

export const Devices: React.FC<DeviceProps> = (props: DeviceProps) => {
    const patientApi = createPatientApi();
    const [offCanvasTitle, setOffCanvasTitle] = useState("");
    const [devices, setDevices] = useState<Array<Device>>([]);
    const [offCanvasShow, setOffCanvasShow] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState<Device | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);
    const [confirmTitle, setConfirmTitle] = useState<string>('');
    const [confirmMessage, setConfirmMessage] = useState<string>('');
    const [showToast, setShowToast] = useState(false);
    const [toastConfig, setToastConfig] = useState<ToastConfig>({
        type: "success" as ErrorTypes,
        title: "",
        icon: "",
    });

    const PLACEHOLDER = <span className="placeholder-wave">
        <span className="placeholder w-100"></span>
    </span>;

    const onSubmit = async (toasterConfig: ToastConfig) => {
        setToastConfig(toasterConfig);
        setShowToast(true);
        getPatientDevices();
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await patientApi.patientsControllerDeletePatientDevice(selectedDevice?.id ?? '', props.patientId!);
            setShowConfirmBox(false);
            getPatientDevices();
            const toasterConfig = {
                type: "success",
                title: "Device deleted successfully",
                icon: "check_circle_outline",
            };
            onSubmit(toasterConfig as ToastConfig);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const deleteDevice = (device: Device) => {
        setShowConfirmBox(true);
        setConfirmTitle('Delete Device');
        setConfirmMessage(`Are you sure you want to delete the device '${device.deviceName}'? This action cannot be undone.`);
        setSelectedDevice(device);
    }

    const handleOffCanvasShow = (device?: Device) => {
        if (device?.id) {
            setOffCanvasTitle("Edit Device");
            setSelectedDevice(device);
        } else {
            setOffCanvasTitle("Add Device");
            setSelectedDevice(undefined);
        }
        setOffCanvasShow(!offCanvasShow);
    };

    useEffect(() => {
        if (props.patientId) {
            getPatientDevices();
        }
    }, [])

    const getPatientDevices = async () => {
        setLoading(true);
        setDevices([]);
        try {
            const response = await patientApi.patientsControllerGetDevices(props.patientId!);
            setDevices(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (<>
        {loading && <Spinner />}
        <div className="row">
            <Toaster
                show={showToast}
                onClose={() => setShowToast(false)}
                type={toastConfig.type}
                title={toastConfig.title}
                message={toastConfig.message}
                icon={toastConfig.icon}
            />
        </div>
        <div className='d-flex align-items-center'>
            <h2 className='h4 m-0'>Devices</h2>
        </div>
        <hr />
        <div className="table-responsive">
            <table className="table border mt-4 rounded overflow-hidden">
                <thead>
                    <tr>
                        <th scope="col" className="py-3 bg-blue-5">Device name</th>
                        <th scope="col" className="py-3 bg-blue-5">Model Name</th>
                        <th scope="col" className="py-3 bg-blue-5">Serial Number</th>
                        <th scope="col" className="py-3 bg-blue-5"></th>
                    </tr>
                </thead>
                <tbody>
                    {!loading && devices.length ? devices.map((device: Device, index: number) => (<>
                        <tr>
                            <td>{device.deviceName}</td>
                            <td>{device.modalName}</td>
                            <td>{device.serialNumber}</td>
                            <td className="text-center w-40px">
                                <a key={index} href='javascript:void(0)' onClick={() => handleOffCanvasShow(device)}>
                                    <EditIcon />
                                </a>
                                <a href='javascript:void(0)' onClick={() => deleteDevice(device)}>
                                    <span className="material-symbols-outlined fs-22 align-text-top ms-2">delete</span>
                                </a>
                            </td>
                        </tr>
                    </>)) : '' }
                    {!loading && !devices.length &&
                        <tr>
                            <td className="text-center" colSpan={4}>No Device Found</td>
                        </tr>
                    }
                    {loading &&
                        Array.from({ length: 2 }).map((item,index) => (
                            <tr key={index}>
                                <td>{PLACEHOLDER}</td>
                                <td>{PLACEHOLDER}</td>
                                <td>{PLACEHOLDER}</td>
                                <td className="text-center w-40px">{PLACEHOLDER}</td>
                            </tr>))
                    }
                </tbody>
            </table>
        </div>
            <a href='javascript:void(0)' className={`d-inline-block border-primary border-bottom`} onClick={() => handleOffCanvasShow()}>
                <span className="lh-sm">Add</span>
                <span className="material-symbols-outlined fs-16 align-text-top me-0">add</span>
            </a>

        <OffCanvas
            title={offCanvasTitle}
            offCanvasShow={offCanvasShow}
            setOffCanvasShow={setOffCanvasShow}
        >
            <AddUpdateDevice onSubmit={onSubmit} patientId={props.patientId!} setOffCanvasShow={setOffCanvasShow} selectedDevice={selectedDevice} />
        </OffCanvas>
        <ConfirmationBox showConfirmBox={showConfirmBox} title={confirmTitle} message={confirmMessage} performAction={handleConfirm} closeConfirmBox={() => setShowConfirmBox(!showConfirmBox)} />
    </>);
}